import { AuthGuard } from './auth-guard.service';
import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';

@Injectable()
export class FrontpageService {

  constructor(private authHttp: AuthHttp) { }

  getAllFrontPageItems(pos: string){
    return this.authHttp.get('/api/frontpage/pos/'+pos).map(res => res.json());
  }

  getFrontPageItem(id: number){
    return this.authHttp.get('/api/frontpage/id/'+id).map(res => res.json());
  }

  create(frontItem: any){
    return this.authHttp.post('/api/frontpage/',frontItem).map(res => res.json());
  }

  delete(id: number){
    return this.authHttp.delete('/api/frontpage/'+id).map(res => res.json());
  }

  update(frontItem: any){
    return this.authHttp.put('/api/frontpage/'+frontItem.id,frontItem).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/frontpage.service.ts